export default __webpack_public_path__ + "images/9P.1a6269e.png";